import { render } from "./FullWidthNarrow.vue?vue&type=template&id=08612375"
import script from "./FullWidthNarrow.vue?vue&type=script&lang=js"
export * from "./FullWidthNarrow.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__